"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconFilterList = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M7,12 L11,12 L11,10 L7,10 L7,12 Z M0,0 L0,2 L18,2 L18,0 L0,0 Z M3,7 L15,7 L15,5 L3,5 L3,7 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconFilterList')(IconFilterList);